/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 *
 * The one rule for the token's `insights` claim, kept free of the insight registry so the
 * auth providers can import it without pulling every insight (and their hooks) into a cycle.
 */

/** An absent claim means everything is allowed; a list is the exact allowed slugs ([] = none). */
export const isInsightAllowed = (allowed: readonly string[] | undefined, slug: string): boolean =>
  allowed === undefined || allowed.includes(slug)
